import { ActionIcon, Button, Grid, Group, Paper, Text } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { SAVE_COUPON, GET_ALL_COUPONS, DELETE_COUPON } from "../services/coupons";
import InputField, { InputFieldMasks, InputFieldTypes } from "../components/input_field";
import { showNotification } from "@mantine/notifications";
import { useApp } from "../contexts/app.context";
import { GET_ALL_USERS } from "../services/users";
import { FaTrash } from "react-icons/fa";

export default function CouponsPage(){
    const [coupons, setCoupons] = useState<any[]>([]);
    const [selectedCoupon, setSelectedCoupon] = useState<any>(null);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);

    const { confirmDialog } = useApp();

    const loadCoupons = () => {
        GET_ALL_COUPONS()
        .then(res => {
            setCoupons(res);
        })
        .catch(err => {
            showNotification({ message: err.message, color: "red" })
        })
    }
    
    const handleSave = () => {
        let params = { ...selectedCoupon };

        setLoadingSave(true)
        SAVE_COUPON(params)
        .then((res) => {
            showNotification({ message: "Cupom Salvo", color: "green" })
            loadCoupons();
            setSelectedCoupon(res)
            setLoadingSave(false);
        })
        .catch(err => {
            showNotification({ message: err.message, color: "red" })
            setLoadingSave(false);
        })
    }

    useEffect(loadCoupons, []);
    
    return <div style={{position: 'relative'}}>
        <Grid>
            <Grid.Col md={12}>
                <Paper shadow="xs" p="md" mb="md">
                    <Group>
                        <InputField
                            name="pl"
                            style={{flex: 1}}
                            onChange={({pl}) => {
                                pl === "new"
                                ? setSelectedCoupon({  })
                                : setSelectedCoupon(coupons.find(p => p._id === pl))
                            }}
                            value={selectedCoupon ? selectedCoupon?._id || "new" : null}
                            fieldType={InputFieldTypes.SELECT}
                            clearable={false}
                            options={[
                                ...coupons.map(p => ({label: p.title, value: p._id})),
                                { value: "new", label: "Adicionar Cupom" }
                            ]}
                        />
                        {selectedCoupon?._id && <ActionIcon size="lg" color="gray" variant="outline"
                            onClick={() => {
                                confirmDialog(
                                    { text: "Do you realy wants to delete this coupon?" },
                                    ({ confirmed }) => {
                                        if(confirmed) DELETE_COUPON(selectedCoupon?._id)
                                        .then(() => {
                                            loadCoupons();
                                            setSelectedCoupon(null);
                                        })
                                        .catch(err => {
                                            showNotification({ message: err.message })
                                        })
                                    }
                                )
                            }}
                        ><FaTrash /></ActionIcon>}
                    </Group>
                </Paper>

                {selectedCoupon && <>
                    <Paper shadow="xs" p="md" mb="md">
                        <InputField
                            name="title"
                            style={{flex: 1}}
                            onChange={({title}) => setSelectedCoupon(sp => ({...sp, title}))}
                            value={selectedCoupon?.title}
                            title="Código do Cupom"
                        />
                    </Paper>
                    <Paper shadow="xs" p="md">
                        <Group grow>
                            <InputField
                                name="type"
                                mb="md"
                                onChange={({type}) => setSelectedCoupon(sp => ({...sp, type}))}
                                value={selectedCoupon?.type}
                                title="Tipo de Desconto"
                                fieldType={InputFieldTypes.SELECT}
                                seachable={false}
                                clearable={false}
                                options={[
                                    {label: "Percentual (%)", value: "percent"},
                                    {label: "Valor Fixo (R$)", value: "static"},
                                ]}
                            />
                            <InputField
                                name="value"
                                mb="md"
                                onChange={({value}) => setSelectedCoupon(sp => ({...sp, value}))}
                                value={selectedCoupon?.value}
                                title="Valor do Desconto"
                                rightSection={selectedCoupon?.type === "percent" && <Text>%</Text>}
                                fieldType={selectedCoupon?.type === "percent" ? InputFieldTypes.NUMBER : undefined}
                                mask={selectedCoupon?.type === "percent" ? undefined : InputFieldMasks.MONEY}
                            />
                        </Group>
                        <InputField
                            name="maximum_usage"
                            mb="md"
                            onChange={({maximum_usage}) => setSelectedCoupon(sp => ({...sp, maximum_usage}))}
                            value={selectedCoupon?.maximum_usage}
                            title="Max. Usos"
                            fieldType={InputFieldTypes.NUMBER}
                        />
                    </Paper>
                    <Group position="right" mt="md">
                        <Button size="md" onClick={handleSave} loading={loadingSave}>Salvar Cupom</Button>
                    </Group>
                </>}

            </Grid.Col>
        </Grid>
    </div>
}
